<template>
  <nav class="groove-builder-tabs" aria-label="Integration workspaces">
    <a href="https://mailbaser.com/integrations?source=groovemail" target="_blank" rel="noopener noreferrer">Universal Integrations <span aria-hidden="true">↗</span></a>
    <router-link to="/settings?type=integeration" class="selected">Integrations Legacy</router-link>
  </nav>
</template>
<script>
import BuilderNav from './BuilderNav.vue';
export default { name: 'IntegrationsNav', components: { BuilderNav } };
</script>
